import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectCustomerComponent } from './select-customer/select-customer.component';
import { OpenedRoutingModule } from './opened-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [SelectCustomerComponent],
  imports: [
    CommonModule,
    OpenedRoutingModule,
    SharedModule
  ]
})
export class OpenedModule { }
